export const getUrlType = (url: any) => {
  if(typeof url === 'string') {
    if(url.startsWith('/') || url.startsWith(window?.location?.origin)) {
      return 'internal';
    } else if (url.startsWith('https://') || url.startsWith('tel:')) {
      return 'external';
    }
  }
  return null;
};
